import { IS_ENROLL } from 'core/constants/environment'

function getFixedPlanBenefits<T extends HasCoreBenefits>(plan: T): PlanBenefit[] {
  const planBenefits: PlanBenefit[] = []

  if (!plan.coreBenefits) {
    return planBenefits
  }
  const {
    hospitalConfinementMedicalCopay,
    hospitalConfinementMedicalMax,
    wellnessBenefitCopay,
    wellnessBenefitMax,
    physicianOfficeCopay,
    physicianOfficeMax,
    genericBrandNamePrescription,
    genericBrandNamePrescriptionMax,
    hospitalAdmissionSicknessInjury,
    hospitalAdmissionSickness,
    hospitalAdmissionInjury,
    hospitalConfinementInjury,
    hospitalConfinementSickness,
    physicianOfficeInjury,
    physicianOfficeSickness
  } = plan.coreBenefits

  // Hospital Admission benefit ============================================
  if (hospitalAdmissionSicknessInjury) {
    planBenefits.push({
      key: 'hadmission',
      value: IS_ENROLL
        ? 'We will pay you ' +
          hospitalAdmissionSicknessInjury +
          ' when admitted to the hospital.'
        : hospitalAdmissionSicknessInjury,
      label: 'Injury/Sickness',
      title: 'Hospital Admission'
    })
  } else if (hospitalAdmissionSickness && hospitalAdmissionInjury) {
    planBenefits.push({
      key: 'hadmission',
      value: [hospitalAdmissionInjury, hospitalAdmissionSickness],
      title: 'Hospital Admission'
    })
  }

  // Hospital Confinement benefit ==========================================
  if (hospitalConfinementMedicalCopay && hospitalConfinementMedicalMax) {
    planBenefits.push({
      key: 'hconfinement',
      value: IS_ENROLL
        ? 'You get paid ' +
          hospitalConfinementMedicalCopay.replace('per Day', 'a day') +
          ' for hospital stays.'
        : hospitalConfinementMedicalCopay,
      label: hospitalConfinementMedicalMax,
      title: IS_ENROLL ? 'Hospital Confinement*' : 'Hospital Confinement'
    })
  } else if (
    hospitalConfinementInjury ||
    hospitalConfinementSickness ||
    hospitalConfinementMedicalMax
  ) {
    planBenefits.push({
      key: 'hconfinement',
      value: [
        hospitalConfinementInjury,
        hospitalConfinementSickness,
        hospitalConfinementMedicalMax
      ].filter(Boolean),
      title: 'Hospital Confinement'
    })
  }

  // Physician Office benefit =============================================
  if (physicianOfficeCopay && physicianOfficeMax) {
    planBenefits.push({
      key: 'poffice',
      value: physicianOfficeCopay,
      label: physicianOfficeMax,
      title: 'Physician Office'
    })
  } else if (physicianOfficeInjury || physicianOfficeSickness || physicianOfficeCopay) {
    planBenefits.push({
      key: 'poffice',
      value: [
        physicianOfficeInjury,
        physicianOfficeSickness,
        physicianOfficeCopay
      ].filter(Boolean),
      title: 'Physician Office'
    })
  }

  if (wellnessBenefitCopay && wellnessBenefitMax) {
    planBenefits.push({
      key: 'wcopay',
      value: wellnessBenefitCopay,
      label: wellnessBenefitMax,
      title: 'Wellness Benefits'
    })
  }

  if (genericBrandNamePrescription) {
    planBenefits.push({
      key: 'pdrug',
      value: genericBrandNamePrescription,
      label: genericBrandNamePrescriptionMax || '',
      title: 'Prescription Drug'
    })
  }

  return planBenefits
}

export default getFixedPlanBenefits
